import type { ReactElement } from 'react';

export const Icon = ({
  name,
  className = 'size-5',
}: {
  name: string;
  className?: string;
}): ReactElement => {
  const paths: Record<string, string> = {
    home: 'M3.5 10.5L12 3.75l8.5 6.75V20a1 1 0 0 1-1 1h-5.25v-6.25h-4.5V21H4.5a1 1 0 0 1-1-1z',
    explore: 'M4 15l5-5 4 4 7-8M4 5h5M4 19h16',
    image: 'M4 5h16v14H4zM8 14l3-3 5 5 2-2 2 2M9 9h.01',
    sparkles:
      'M12 3l1.2 4.3L17 8.5l-3.8 1.2L12 14l-1.2-4.3L7 8.5l3.8-1.2L12 3zM5 14l.7 2.3L8 17l-2.3.7L5 20l-.7-2.3L2 17l2.3-.7L5 14zM19 15l.7 2.3L22 18l-2.3.7L19 21l-.7-2.3L16 18l2.3-.7L19 15z',
    video: 'M4 6h12v12H4zM16 10l4-2v8l-4-2',
    canvas: 'M5 5h6v6H5zM13 13h6v6h-6zM8 11v4h5',
    apps: 'M5 5h5v5H5zM14 5h5v5h-5zM5 14h5v5H5zM14 14h5v5h-5z',
    workflow: 'M4 7h6v6H4zM14 7h6v3h-6zM14 14h6v3h-6zM10 10h4',
    characters: 'M12 12a4 4 0 100-8 4 4 0 000 8zM5 21a7 7 0 0114 0',
    watch: 'M4 7h16v12H4zM4 7l3-3 3 3 3-3 3 3 3-3',
    cinema: 'M4 7h16v12H4zM4 7l3-3 3 3 3-3 3 3 3-3',
    projects: 'M3 7h7l2 2h9v10H3z',
    assets:
      'M6.5 5.5h14v12h-14zM3.5 8.5v12h14M9 14l2.75-2.75 3.25 3.25 2.25-2.25 3.25 3.25',
    account: 'M12 12a4 4 0 100-8 4 4 0 000 8zM5 21a7 7 0 0114 0',
    menu: 'M4 7h16M4 12h16M4 17h16',
    close: 'M6 6l12 12M18 6L6 18',
    arrow: 'M5 12h14M14 7l5 5-5 5',
    plus: 'M12 5v14M5 12h14',
    search: 'M10.5 18a7.5 7.5 0 100-15 7.5 7.5 0 000 15zM16.5 16.5L21 21',
    sun: 'M12 4V2M12 22v-2M4.93 4.93L3.52 3.52M20.48 20.48l-1.41-1.41M4 12H2M22 12h-2M4.93 19.07L3.52 20.48M20.48 3.52l-1.41 1.41M12 8a4 4 0 100 8 4 4 0 000-8z',
    moon: 'M20 15.5A8 8 0 018.5 4 8.5 8.5 0 1020 15.5z',
    settings:
      'M12 9a3 3 0 100 6 3 3 0 000-6zM19.4 15a1.7 1.7 0 00.34 1.88l.06.06-2.12 2.12-.06-.06a1.7 1.7 0 00-1.88-.34 1.7 1.7 0 00-1 1.55V20.3h-3v-.09a1.7 1.7 0 00-1-1.55 1.7 1.7 0 00-1.88.34l-.06.06-2.12-2.12.06-.06A1.7 1.7 0 007.08 15a1.7 1.7 0 00-1.55-1H5.4v-3h.13a1.7 1.7 0 001.55-1 1.7 1.7 0 00-.34-1.88l-.06-.06L8.8 5.94l.06.06a1.7 1.7 0 001.88.34 1.7 1.7 0 001-1.55V4.7h3v.09a1.7 1.7 0 001 1.55 1.7 1.7 0 001.88-.34l.06-.06 2.12 2.12-.06.06A1.7 1.7 0 0019.4 10a1.7 1.7 0 001.55 1h.13v3h-.13a1.7 1.7 0 00-1.55 1z',
    card: 'M3 6h18v12H3zM3 10h18M7 15h3',
    gift: 'M4 10h16v10H4zM3 7h18v3H3zM12 7v13M12 7H8.5a2 2 0 110-4C11 3 12 7 12 7zm0 0h3.5a2 2 0 100-4C13 3 12 7 12 7z',
    'user-plus':
      'M9 11a4 4 0 100-8 4 4 0 000 8zM2 20a7 7 0 0114 0M19 8v6M16 11h6',
    monitor: 'M3 4h18v13H3zM8 21h8M12 17v4',
    globe:
      'M12 21a9 9 0 100-18 9 9 0 000 18zM3 12h18M12 3c2.2 2.5 3.3 5.5 3.3 9S14.2 18.5 12 21M12 3C9.8 5.5 8.7 8.5 8.7 12S9.8 18.5 12 21',
    switch: 'M7 7h13M16 3l4 4-4 4M17 17H4M8 13l-4 4 4 4',
    logout: 'M10 4H5a2 2 0 00-2 2v12a2 2 0 002 2h5M14 8l4 4-4 4M8 12h10',
    check: 'M5 12l4 4L19 6',
    list: 'M4 6h16M4 12h16M4 18h16M8 6v.01M8 12v.01M8 18v.01',
    timeline: 'M4 7h16v12H4zM8 11h2M8 15h2M14 11h2M14 15h2',
    scroll: 'M8 4h8a2 2 0 012 2v12l-3-2-3 2-3-2-3 2V6a2 2 0 012-2z',
    campaign:
      'M4 10v4a2 2 0 002 2h1l4 4V4L7 8H6a2 2 0 00-2 2zM15.5 8.5a5 5 0 010 7M18.5 6a8 8 0 010 12',
    skill:
      'M15 12h-5M15 8h-5M19 17V5a2 2 0 0 0-2-2H4M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3',
    code: 'M9 6l-6 6 6 6M15 6l6 6-6 6',
    document: 'M8 4h6l4 4v12H8zM14 4v4h4',
  };
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      viewBox={name === 'mylo-lab' ? '0 0 102 102' : '0 0 24 24'}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
    >
      {name === 'mylo-lab' ? (
        <g
          transform="translate(9 29) skewX(-6)"
          fill="currentColor"
          stroke="none"
        >
          <path d="M7 0H25V44H16V8H14L12 31C11 41 7 44 0 44V35C3 35 4 34 5 28Z" />
          <path
            fillRule="evenodd"
            d="M36 0H48L56 44H46L45 34H38L36 44H27ZM39 26H44L42 10Z"
          />
          <path
            fillRule="evenodd"
            d="M60 0H85V9H69V17H75C84 17 88 21 88 30C88 40 83 44 74 44H60ZM69 25V36H73C77 36 79 35 79 30C79 26 77 25 73 25Z"
          />
        </g>
      ) : name === 'agent' ? (
        <g fill="currentColor" stroke="none">
          <circle cx="12" cy="3.75" r="2.25" />
          <circle cx="3.75" cy="12" r="2.25" />
          <circle cx="12" cy="12" r="2.25" />
          <circle cx="20.25" cy="12" r="2.25" />
          <circle cx="12" cy="20.25" r="2.25" />
        </g>
      ) : (
        <path d={paths[name] ?? paths.explore} />
      )}
    </svg>
  );
};
